import type { HolsterDrawSide, HolsterMountType, ItemDetail } from "../../data/catalog.ts";
import { capitalize } from "../utils.ts";
import type { AttrRowSpec } from "./AttrRow.tsx";

type HolsterAttrs = NonNullable<ItemDetail["holsterAttributes"]>;

function formatMountType(t: HolsterMountType): string {
  switch (t) {
    case "iwb":
      return "IWB";
    case "owb":
      return "OWB";
    case "drop_leg":
      return "Drop-leg";
    default:
      return capitalize(t);
  }
}

function formatDrawSide(s: HolsterDrawSide): string {
  switch (s) {
    case "left":
      return "Left";
    case "right":
      return "Right";
    case "ambidextrous":
      return "Ambidextrous";
  }
}

export function HolsterSpecLine({ a }: { a: HolsterAttrs }) {
  // Glance summary: fit · mount · side.
  return (
    <p className="text-[15px] font-medium text-slate-600">
      {`${a.fitModel} · ${formatMountType(a.mountType)} · ${formatDrawSide(a.drawSide)}`}
    </p>
  );
}

export function buildHolsterRows(a: HolsterAttrs): AttrRowSpec[] {
  return [
    { label: "Manufacturer", value: a.manufacturer, required: true },
    { label: "Fits", value: a.fitModel, required: true },
    { label: "Mount type", value: formatMountType(a.mountType), required: true },
    { label: "Draw side", value: formatDrawSide(a.drawSide), required: true },
    { label: "Retention", value: a.retentionLevel },
    { label: "Material", value: a.material ? capitalize(a.material) : null },
  ];
}
